import { j as t } from "../../../_virtual/jsx-runtime.js";
import { cn as e } from "../../../lib/utils.js";
const f = ({
  children: l,
  position: a = "top",
  className: r
}) => {
  const s = () => {
    switch (a) {
      case "top":
        return "bottom-full left-1/2 -translate-x-1/2 mb-2";
      case "bottom":
        return "top-full left-1/2 -translate-x-1/2 mt-2";
      case "left":
        return "right-full top-1/2 -translate-y-1/2 mr-2";
      case "right":
        return "left-full top-1/2 -translate-y-1/2 ml-2";
      default:
        return "bottom-full left-1/2 -translate-x-1/2 mb-2";
    }
  };
  return /* @__PURE__ */ t.jsx("div", { className: e("absolute z-50", s()), children: /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: e(
        "bg-grey-600 rounded-lg p-4 text-white shadow-lg flex flex-col gap-2 w-max",
        r
      ),
      children: [
        l,
        /* @__PURE__ */ t.jsx("div", { className: "absolute left-1/2 -bottom-2 -translate-x-1/2 w-4 h-4 bg-grey-600 transform rotate-45" })
      ]
    }
  ) });
};
export {
  f as default
};
